/** Namespace `auth` (Login + Magic-Link) — Extras, befüllt während der Migration. */
export const login = {
  de: {
    auth: {
      tagline: 'Dental Practice Management',
      password: 'Passwort',
      magicLink: 'Magic Link',
      username: 'Benutzername',
      email: 'Email',
      signIn: 'Einloggen',
      loggingIn: 'Einloggen…',
      loginErrorDot: 'Ungültiger Benutzername oder Passwort.',
      requestFailed: 'Anfrage fehlgeschlagen.',
      magicIntro: 'Gib deine Email an — wir schicken dir einen Login-Link, der <strong>60 Minuten</strong> gültig ist.',
      sendLoginLink: 'Login-Link senden',
      sendingLink: 'Sende Link…',
      mailSentTitle: 'Mail unterwegs',
      mailSentBody: 'Falls die Email-Adresse zu einem aktiven Account gehört, ist gerade ein Login-Link auf dem Weg in dein Postfach.',
      noMailPrefix: 'Keine Mail erhalten? Schau im Spam-Ordner oder',
      requestAgain: 'erneut anfordern',
      noMailSuffix: '.',
      footer: 'SeaDent Mallorca · Admin',
      // Magic-Link-Verifizierung
      verifyNoToken: 'Kein Token in der URL gefunden.',
      verifyFailed: 'Login-Link konnte nicht verifiziert werden.',
      verifyingTitle: 'Login-Link wird geprüft…',
      verifyingBody: 'Einen Moment bitte.',
      loggedInTitle: 'Eingeloggt',
      redirecting: 'Du wirst gleich weitergeleitet…',
      linkExpiredTitle: 'Link abgelaufen',
      loginFailedTitle: 'Login fehlgeschlagen',
      linkExpiredHint: 'Magic Links sind 60 Minuten gültig. Bitte fordere einen neuen an.',
      linkInvalidHint: 'Der Link ist möglicherweise nicht mehr gültig oder wurde manipuliert.',
      backToLogin: 'Zurück zum Login',
    },
  },
  es: {
    auth: {
      tagline: 'Gestión de Clínica Dental',
      password: 'Contraseña',
      magicLink: 'Enlace mágico',
      username: 'Usuario',
      email: 'Correo electrónico',
      signIn: 'Iniciar sesión',
      loggingIn: 'Iniciando sesión…',
      loginErrorDot: 'Usuario o contraseña incorrectos.',
      requestFailed: 'La solicitud ha fallado.',
      magicIntro: 'Indique su correo electrónico: le enviaremos un enlace de acceso válido durante <strong>60 minutos</strong>.',
      sendLoginLink: 'Enviar enlace de acceso',
      sendingLink: 'Enviando enlace…',
      mailSentTitle: 'Correo en camino',
      mailSentBody: 'Si la dirección de correo electrónico pertenece a una cuenta activa, le enviaremos un enlace de acceso a su bandeja de entrada.',
      noMailPrefix: '¿No ha recibido el correo? Revise la carpeta de spam o',
      requestAgain: 'solicítelo de nuevo',
      noMailSuffix: '.',
      footer: 'SeaDent Mallorca · Admin',
      // Verificación del enlace mágico
      verifyNoToken: 'No se ha encontrado ningún token en la URL.',
      verifyFailed: 'No se ha podido verificar el enlace de acceso.',
      verifyingTitle: 'Verificando el enlace de acceso…',
      verifyingBody: 'Un momento, por favor.',
      loggedInTitle: 'Sesión iniciada',
      redirecting: 'Será redirigido en breve…',
      linkExpiredTitle: 'Enlace caducado',
      loginFailedTitle: 'Error de acceso',
      linkExpiredHint: 'Los enlaces mágicos son válidos durante 60 minutos. Solicite uno nuevo, por favor.',
      linkInvalidHint: 'Es posible que el enlace ya no sea válido o haya sido manipulado.',
      backToLogin: 'Volver al inicio de sesión',
    },
  },
};
